import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Contact } from "@/components/Contact";

export const Contacto = () => {
  useEffect(() => {
    document.title = "Contacto - Ruta 360";
  }, []);

  return (
    <div data-testid="contacto-page" className="bg-white min-h-screen">
      <Header />
      <main className="pt-[72px]">
        <Contact />
      </main>
      <Footer />
    </div>
  );
};
